"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AncestryEnumToJSON = exports.AncestryEnumFromJSONTyped = exports.AncestryEnumFromJSON = exports.AncestryEnum = void 0;
/**
 * list of ancestry descriptors for the relative
 * @export
 */
exports.AncestryEnum = {
    AfricanAmerican: 'african_american',
    Ashkenazi: 'ashkenazi',
    Asian: 'asian',
    Hispanic: 'hispanic',
    Mediterranean: 'mediterranean',
    NativeAmerican: 'native_american',
    PacificIslander: 'pacific_islander',
    Sephardic: 'sephardic',
    White: 'white',
    Other: 'other',
    Unknown: 'unknown'
};
function AncestryEnumFromJSON(json) {
    return AncestryEnumFromJSONTyped(json, false);
}
exports.AncestryEnumFromJSON = AncestryEnumFromJSON;
function AncestryEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AncestryEnumFromJSONTyped = AncestryEnumFromJSONTyped;
function AncestryEnumToJSON(value) {
    return value;
}
exports.AncestryEnumToJSON = AncestryEnumToJSON;
